import type { ICategory, ILocalizedText, IModuleSummary } from '@platform/core/types';
import { catalogLabel, moduleNav, navGroups } from '@platform/navigation';

/**
 * Категорія модуля в конструкторі, як у прототипі v4 (bCat/bCatEls): основний модуль — лише «Основа» (Core); інший — категорія його групи
 * верхнього меню (cat модуля після shapeModules0) серед усіх категорій, крім «Основи»; підписи — назви груп прототипу («Управління
 * відносинами», «Правові»), без групи — назва категорії каталогу. Чиста функція.
 */
export function builderCategories(module: Pick<IModuleSummary, 'key' | 'core' | 'category'>, categories: readonly ICategory[],
  label: (text: ILocalizedText | null | undefined) => string): { value: string; options: Array<{ key: string; label: string }> } {
  const groups = navGroups();
  const name = (key: string) => {
    const group = groups.find((g) => g.category === key);
    return (group && label(catalogLabel(group))) || label(categories.find((c) => c.key === key)?.name) || key;
  };
  if (module.core) return { value: 'Core', options: [{ key: 'Core', label: name('Core') }] };
  const own = groups.find((g) => g.key === moduleNav(module.key).group)?.category ?? module.category;
  const keys = [...categories].sort((a, b) => a.sort - b.sort).map((c) => c.key).filter((k) => k !== 'Core');
  return { value: own, options: (keys.includes(own) ? keys : [...keys, own]).map((key) => ({ key, label: name(key) })) };
}
